import SensorReportPage from './sensor-report-page';

export default SensorReportPage;